import React from "react";
import Marty from "marty";
import { Modal } from "react-bootstrap";

let ConfirmModal = React.createClass({
    getInitialState(){
        return {
            show: this.props.show
        };
    },
    getDefaultProps() {
        return {
            message: "Are you sure?"
        };
    },
    propTypes: {
        show: React.PropTypes.bool.isRequired,
        confirm: React.PropTypes.func,
        message: React.PropTypes.string
    },
    componentWillReceiveProps(newProps) {
        this.setState({show: newProps.show});
    },
    close() {
        this.setState({show: false});
        this.app.navActions.closeModal("confirm");
    },
    confirm() {
        this.close();
        this.props.confirm();
    },
    render() {
        return (
            <Modal enforceFocus={true} onHide={()=>{}} backdrop="static" dialogClassName="eo-modal eo-confirm-modal" show={this.state.show}>
                <Modal.Body>
                    <span>{this.props.message}</span>
                </Modal.Body>
                <Modal.Footer>
                    <span className="eo-btn-submit eo-btn-inline float-right gray" onClick={this.close}>No</span>
                    <span className="eo-btn-submit eo-btn-inline float-right" onClick={this.confirm}>Yes</span>
                </Modal.Footer>
            </Modal>
        );
    }
});

export default Marty.createContainer(ConfirmModal);



/** WEBPACK FOOTER **
 ** ./app/utils/components/ConfirmModal.js
 **/